import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../DataTable/DataTable"
import CreditCardForm from "../../BookingFlow/CreditCardForm"

class CustomerBuilderCardsTab extends React.Component {
  
  constructor(props) {
    super(props);
  };

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'cards',
      'tab-pane': true,
    });

    return (
      <div className={tabClasses}>
        {this.renderCardHeaderErrors()}
        {this.renderCardForm()}
      </div>
    );
  };

  renderCardForm(){
    return(
      <DataTable endpoint={this.props.customer_cards_path} date_format={this.props.date_format} time_format={this.props.time_format} no_data_text={I18n.t('none')} />
    );
  };

  renderCardHeaderErrors(count=false) {
    if (this.props.errors && this.props.errors.cards_header_errors) {
      var previousNameError = false
      var errors = this.props.errors.cards_header_errors.map((error, idx) => {
        if (error.toLowerCase().includes('name')) {
          if (!previousNameError) {
            previousNameError = true
            return <li key={idx}>{I18n.t('name_on_card_error')}</li>;
          };
        } else if (error.toLowerCase().includes('number') || error.toLowerCase().includes('month') || error.toLowerCase().includes('year') || error.toLowerCase().includes('amount')) {
          return <li key={idx}>{error}</li>;
        } else if (error.toLowerCase().includes('verification value')) {
          return <li key={idx}>{I18n.t('security_code_error')}</li>
        } else return <li key={idx}>{error}</li>
      });
      if(count){
        return errors.length
      } else{
        return (
          <div className="alert alert-danger">
            <ul>{errors}</ul>
          </div>
        );
      };
    };
  };

}

export default CustomerBuilderCardsTab